import { CreatePromptModelRequest, PromptModel } from 'api/model';
import instance from '../axios_instance';

export const getModels = async (): Promise<PromptModel[]> => {
  const response = await instance.get<PromptModel[]>('/models');
  return response.data;
};

export const getModel = async (id: string): Promise<PromptModel> => {
  const response = await instance.get<PromptModel>(`/models/${id}`);
  return response.data;
};

export const createModel = async (model: CreatePromptModelRequest): Promise<PromptModel> => {
  if (model.secret_id == '' || model.secret_id == undefined || model.secret_id == null) {
    delete model.secret_id;
  }
  const response = await instance.post<PromptModel>(`/models`, model);
  return response.data;
};

export const updateModel = async (id: string, model: CreatePromptModelRequest): Promise<PromptModel> => {
  if (model.secret_id == '' || model.secret_id == undefined || model.secret_id == null) {
    delete model.secret_id;
  }
  const response = await instance.put<PromptModel>(`/models/${id}`, model);
  return response.data;
};

export const removeModel = async (id: string) => {
  return await instance.delete(`/models/${id}`);
};
